import CreateAppointment from "components/Modals/create/CreateAppointment"
import Appointment from "components/Modals/show-edit/Appointment"
import Flag from "components/Tag/Flag"
import React, { useEffect, useState } from "react"
import ReactDOM from "react-dom"
import { Col } from "react-grid"
import { Button, Container, Row } from "reactstrap"
import ReactBSAlert from "react-bootstrap-sweetalert"
import { hoursToMinutes } from "utils/timeHandling"

function AppointmentsTable(props) {
  const [selectedAppointment, setSelectedAppointment] = useState({})
  const [activityRemainingMinutes, setActivityRemainingMinutes] = useState(0)

  const [createAppointmentModalOpen, setCreateAppointmentModalOpen] =
    useState(false)
  const [appointmentModalOpen, setAppointmentModalOpen] = useState(false)
  const [savingSchedule, setSavingSchedule] = useState(false)
  const [alert, setAlert] = useState(null)

  const hideAlert = () => setAlert(null)

  const showAlert = (message) => {
    setAlert(
      ReactDOM.createPortal(
        <ReactBSAlert
          warning
          style={{ display: "block" }}
          title="Atenção!"
          onConfirm={hideAlert}
          onCancel={hideAlert}
          confirmBtnBsStyle="warning"
          confirmBtnText="Ok"
          btnSize=""
        >
          {message}
        </ReactBSAlert>,
        document.body
      )
    )
  }

  useEffect(() => {
    const totalPerformedMinutes = hoursToMinutes(props.activity.performedHours)
    const totalEstmatedMinutes = hoursToMinutes(props.activity.estimatedHours)

    setActivityRemainingMinutes(totalEstmatedMinutes - totalPerformedMinutes)
  }, [props.activity, activityRemainingMinutes])

  // Mesmos campos obrigatórios do backend pra criar a agenda
  // (schedule/create): customer, address, date e activity começam vazios
  // ("") até o usuário preencher. timeFrom/timeTo/timeTotal etc. já saem
  // com "00:00" por padrão, então não bloqueiam a criação do rascunho.
  // Se algum desses estiver faltando, saveDraftSchedule falha com 400 no
  // clique de "Adicionar Apontamento" e o modal não abre na primeira
  // tentativa. Desabilitando o botão até esses campos existirem, o
  // primeiro clique sempre funciona.
  const scheduleHeaderIncomplete =
    !props.schedule.customer ||
    !props.schedule.address ||
    !props.schedule.date ||
    !props.schedule.activity

  return (
    <>
      {alert}
      <Row className="my-3" style={{ justifyContent: "right" }}>
        <Button
          className="btn-round btn-icon"
          color="primary"
          onClick={async (e) => {
            const dateUsed = props.appointments.filter((app) => {
              return app.date.split("T")[0] === props.schedule.date
            })
            if (dateUsed.length > 0) {
              showAlert(
                "Não pode haver dois apontamentos da mesma tarefa no mesmo dia"
              )
              return
            }
            if (!props.schedule._id) {
              setSavingSchedule(true)
              try {
                await props.saveDraftSchedule()
              } catch (error) {
                showAlert("Erro ao salvar a agenda")
                return
              } finally {
                setSavingSchedule(false)
              }
            }
            setCreateAppointmentModalOpen(true)
          }}
          disabled={
            savingSchedule ||
            scheduleHeaderIncomplete ||
            props.appointments.filter((app) => {
              return app.date.split("T")[0] === props.schedule.date
            }).length > 0 ||
            props.schedule.serviceOrder ||
            props.schedule.status === "PA" ||
            props.activity.status === "F" ||
            (!props.hasBalance && props.activity.hoursSettled)
          }
          size="sm"
        >
          <span className="btn-inner--icon mr-1">
            <i className="fas fa-plus" />
          </span>
          <span className="btn-inner--text">Adicionar Apontamento</span>
        </Button>
      </Row>
      {scheduleHeaderIncomplete && (
        <Row className="my-1" style={{ justifyContent: "right" }}>
          <small className="text-muted">
            Preencha cliente, local e a descrição da atividade da agenda antes de adicionar apontamentos.
          </small>
        </Row>
      )}
      {props.appointments.length > 0 && (
        <Container className="mb-6">
          <Row>
            <Col xs={3}>
              <h4>Data</h4>{" "}
            </Col>
            <Col xs={7}>
              <h4>Descricão</h4>
            </Col>
            <Col xs={1}>
              <h4>Horas</h4>
            </Col>
            <Col xs={1}>
              <h4>OS</h4>
            </Col>
          </Row>
          {props.appointments.map((appointment, index) => {
            return (
              <Row
                key={index}
                className={"my-3"}
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setAppointmentModalOpen(true)
                  setSelectedAppointment(appointment)
                }}
              >
                <Col xs={3}>
                  {new Date(
                    appointment.date.split("T")[0] + " 00:00"
                  ).toLocaleDateString("pt-BR")}
                </Col>
                <Col
                  xs={7}
                  style={{ overflow: "hidden", textOverflow: "ellipsis" }}
                >
                  {appointment.description.slice(0, 40)}
                </Col>
                <Col xs={1}>{appointment.hours}</Col>
                <Col xs={1} style={{ textAlign: "-webkit-center" }}>
                  {appointment.osCreated ? (
                    <Flag backgroundColor="green">v</Flag>
                  ) : (
                    <Flag backgroundColor="red">x</Flag>
                  )}
                </Col>
              </Row>
            )
          })}
        </Container>
      )}
      {props.appointments.length <= 0 && (
        <h3> Não há apontamentos criados para essa atividade</h3>
      )}
      <CreateAppointment
        isOpen={createAppointmentModalOpen}
        activityRemainingMinutes={activityRemainingMinutes}
        schedule={props.schedule}
        activity={props.activity}
        title={"Criar Apontamento"}
        action={"Criar"}
        updateActivities={() => {
          props.updateActivities()
        }}
        closeModal={() => {
          setCreateAppointmentModalOpen(false)
        }}
      />
      <Appointment
        isOpen={appointmentModalOpen}
        activityRemainingMinutes={activityRemainingMinutes}
        schedule={props.schedule}
        activity={props.activity}
        appointment={selectedAppointment}
        title={"Editar Apontamento"}
        action={"Salvar"}
        updateActivities={() => {
          props.updateActivities()
        }}
        closeModal={() => {
          setAppointmentModalOpen(false)
        }}
      />
    </>
  )
}

export default AppointmentsTable
